var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "glide__slide" },
    [
      _vm.item.name
        ? _c(
            "div",
            { staticClass: "glide__upper" },
            [
              _c(
                "div",
                { staticClass: "glide__slide-box" },
                [
                  _vm.item.name
                    ? _c("BaseCaption", {
                        staticClass: "glide__title",
                        attrs: { text: _vm.item.name, tag: "h1" }
                      })
                    : _vm._e(),
                  _vm.item.ageAndDealer
                    ? _c("BaseText", {
                        staticClass: "glide__caption",
                        attrs: { text: _vm.item.ageAndDealer }
                      })
                    : _vm._e(),
                  _vm.item.ageCategory
                    ? _c("BaseText", {
                        staticClass: "glide__text",
                        attrs: { text: _vm.item.ageCategory }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "glide__social" },
                [
                  _c("BaseText", {
                    staticClass: "glide__text glide__text--mb-hidden",
                    attrs: { text: "Поділитись малюнком" }
                  }),
                  _c("SocialBtnsList", {
                    attrs: { id: _vm.item.id, shareBtns: _vm.shareBtns }
                  })
                ],
                1
              ),
              _c("VotingBlock", { attrs: { item: _vm.item } })
            ],
            1
          )
        : _vm._e(),
      _vm.item.place
        ? _c(
            "div",
            { staticClass: "glide__upper" },
            [
              _vm.item.place
                ? _c("BaseCaption", {
                    staticClass: "glide__caption",
                    attrs: { text: _vm.item.placeText }
                  })
                : _vm._e(),
              _vm.item.winner
                ? _c("BaseText", {
                    staticClass: "glide__text",
                    attrs: { text: _vm.item.winner }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c("BaseLazyLoadingimg", {
        attrs: { srcSet: [_vm.srcset[0], _vm.srcset[1], _vm.srcset[2]] }
      }),
      _c(
        "div",
        { staticClass: "glide__inner" },
        [
          _vm.item.caption
            ? _c("BaseCaption", {
                staticClass: "glide__caption",
                attrs: { tag: "h3", text: _vm.item.caption }
              })
            : _vm._e(),
          _vm.item.descr
            ? _c("BaseText", {
                staticClass: "glide__text",
                attrs: { text: _vm.item.descr }
              })
            : _vm._e(),
          _vm.item.jobName
            ? _c("BaseCaption", {
                staticClass: "glide__caption",
                attrs: { text: _vm.item.jobName }
              })
            : _vm._e(),
          _vm.item.jobDescription
            ? _c("BaseText", {
                staticClass: "glide__text",
                attrs: { text: _vm.item.jobDescription }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e02dcca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e02dcca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/AppSliderItem.vue
// module id = CkdG
// module chunks = 0 1 2 5 6